<template>
  <div class="logic-wrapper inspector-wrap">
    <div class="d-inline-flex mb-5">
      <div class="form-check mr-3" v-if="logic_fields.length">
        <input
          class="form-check-input select-all mt-0"
          type="checkbox"
          v-model="selectAll"
        />
      </div>
      <h4 class="mr-3 mb-0">
        Logic
      </h4>
      <div class="d-flex align-items-center">
        <span class="cursor-pointer" @click="addNewLogic()" v-if="logic_fields.length>0 && logic_fields[0].logicNode.condition_type != 'probability' &&  logic_fields[0].logicNode.condition_type != 'stt'">
          <i class="fas fa-plus-circle fa-xl"></i>
        </span>
        <span
          v-if="isSelected && logic_fields.length"
          class="cursor-pointer ml-3"
          @click="deleteAllLogic()"
        >
          <i class="fa fa-trash"></i>
        </span>
      </div>
    </div>
    <div v-for="(logicitem, index) in logic_fields" :key="index" class="mb-3">
      <div class="fields-wrapper  is-multi-node">
        <div class="form-check select-single">
          <input
            class="form-check-input"
            type="checkbox"
            @change="checkSingleSelect"
            v-model="logicitem.logicNode.selectSingle"
          />
        </div>
        <div
          class="action-buttons"
          v-if="
            !logicitem.logicNode.isCopied || logicitem.logicNode.selectSingle">
          <span
            v-if="!logicitem.logicNode.isCopied && logicitem.logicNode.condition_type!='probability'  && logicitem.logicNode.condition_type!='stt'"
            class="action-item "
            @click="copyLogic(index, logicitem)"
          >
            <i class="fa fa-copy"></i>
          </span>
          <span
            class="action-item"
            @click="deleteLogic(logicitem)"
          >
            <i class="fa fa-trash"></i>
          </span>
        </div>
        <div class="row">
          <div class="col-10 logic-items-list">
             
              <div class=" logic-item">
                <label>Logic Type</label>
                <select class="custom-select" v-model="logicitem.logicNode.condition_type">
                  <option v-for="(item, key) in options.condition_type" :value="item.key">{{ item.value }}</option>
                </select>
              </div>

              <template v-if="logicitem.logicNode.condition_type == 'touch'">
              <div class=" logic-item" v-if="logicitem.logicNode.condition_type">
                <label>Type</label>
                <select class="custom-select" v-model="logicitem.logicNode.logic_type">
                  <option v-for="item in options.logic_type[logicitem.logicNode.condition_type]" :value="item.key">{{
                      item.value
                    }}
                  </option>
                </select>
              </div>
              <div class="logic-item" v-if="logicitem.logicNode.logic_type">
                <label>{{ logicitem.logicNode.logic_type == 'scene' ? 'Object' : 'Media' }} Type</label>
                <select class="custom-select" v-model="logicitem.logicNode.media_type" @click="noElements()" @change="getMedia(logicitem.logicNode.media_type,index)" >
                  <option v-for="item in options.media_type[logicitem.logicNode.logic_type]" :value="item.key">{{
                      item.value
                    }}
                  </option>
                </select>
              </div>

              <template v-if="logicitem.logicNode.logic_type == 'scene'">
                <div class="logic-item" v-if="logicitem.logicNode.media_type">
                  <label>Asset</label>
                  <select class="custom-select" v-model="logicitem.logicNode.object_type"
                          @change="getMedia(logicitem.logicNode.object_type,index)" @click="noElements()">
                    <option v-for="item in options.object_type[logicitem.logicNode.media_type]" :value="item.key">{{
                        item.value
                      }}
                    </option>
                  </select>
                </div>
                <div class="logic-item" v-if="logicitem.logicNode.object_type">
                  <label>Asset Name</label>
                  <select class="custom-select" v-model="logicitem.logicNode.media_name">
                    <option v-for="item in media_names[index]">{{ item.name }}</option>
                  </select>
                </div>
              </template>
              <template v-if="logicitem.logicNode.logic_type == 'screen'">
                <div class="logic-item" v-if="logicitem.logicNode.media_type">
                  <label>Media Name</label>
                  <select class="custom-select" v-model="logicitem.logicNode.media_name">
                    <option v-for="item in media_names[index]">{{ item }}</option>
                  </select>
                </div>
              </template>
       
              <div class="logic-item" v-if="logicitem.logicNode.media_name">
                <label>Interaction Type</label>
                <select class="custom-select" v-model="logicitem.logicNode.interaction_type">
                  <option v-for="item in options.interaction_type[logicitem.logicNode.object_type ? logicitem.logicNode.object_type : logicitem.logicNode.media_type]"
                          :value="item.key">{{
                      item.value
                    }}
                  </option>
                </select>
              </div>
              <div class="logic-item logic-item-decision" v-if="logicitem.logicNode.interaction_type == 'swipe' || logicitem.logicNode.interaction_type == 'tap'">
                  <label>Decision</label>
                <multiselect
              v-model="logicitem.logicNode.decision"
              :options="options.decision_type[logicitem.logicNode.interaction_type]"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              :taggable="true"
              :multiple="true"
              placeholder=""
            ></multiselect>
</div>

   </template>

    <template v-if="logicitem.logicNode.condition_type == 'stt'">
             <div class=" logic-item"  v-if="logicitem.logicNode.condition_type">
                  <label>Number of conditions</label>
                  <input :disabled="logicitem.logicNode.isReadOnly"
                    class="form-control"
                    min="0"
                    max="100"
                    maxlength="3"
                    pattern="\d*"
                    type="text"
                    v-model="logicitem.logicNode.no_of_conditions"
                    @change="probabilityPaths(logicitem.logicNode.no_of_conditions)"
                  />
                </div>
                <div class=" logic-item extendable" v-if="logicitem.logicNode.no_of_conditions > 0">
                  <label>Condition - verbal</label>
                  <div class="input-group mb-2" v-for="index in parseInt(logicitem.logicNode.no_of_conditions)" :key="index" @click="tagToSelect(index)">
                    <multiselect
                        v-model="logicitem.logicNode.verbalCondition[index]"
                        :options="verbaloptions"
                        :searchable="true"
                        :close-on-select="true"
                        :show-labels="false"
                        :taggable="true"
                        :multiple="true"
                        placeholder=""
                        :clear-on-select="false" 
                        :preserve-search="true" 
                        tag-placeholder="Add this as new tag" 
                        @tag="addTag"
                        label="title" 
                        track-by="title" 
                        :preselect-first="false"
                  ></multiselect>
                  </div>
                </div>
      </template>
 <template v-if="logicitem.logicNode.condition_type == 'probability'">
                <div class=" logic-item"  v-if="logicitem.logicNode.condition_type">
                  <label>Number of Scenes</label>
                  <input :disabled="logicitem.logicNode.isReadOnly"
                    class="form-control"
                    min="0"
                    max="100"
                    maxlength="3"
                    pattern="\d*"
                    type="text"
                    v-model="logicitem.logicNode.no_of_scenes"
                    @change="probabilityPaths(logicitem.logicNode.no_of_scenes)"
                  />
                </div>
                <div class=" logic-item" v-if="logicitem.logicNode.no_of_scenes > 0">
                  <label>Percentage</label>
                  <div class="input-group mb-2" v-for="index in parseInt(logicitem.logicNode.no_of_scenes)"
                       :key="index">
                    <input 
                      class="form-control"
                      min="0"
                      max="100"
                      maxlength="2"
                      pattern="\d*"
                      type="text"
                      readonly
                      v-model="logicitem.logicNode.percentage[index] = (100 / logicitem.logicNode.no_of_scenes).toFixed(2)"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
              </template>
        
            </div>
          <div class="col-2">
                 <template v-if="logicitem.logicNode.condition_type == 'touch'">
            <div>
              <label>Path</label>
                <select  class="custom-select"  v-model="logicitem.logicNode.path">
                <option :value="'Duplicated_Scene'+(parseInt(lastScene.key.replace(/[^0-9]/g, ''))+index+customId)" >
                    New duplicated Scene {{ parseInt(lastScene.key.replace(/[^0-9]/g, ''))+index+customId}}
                  </option>
                  <option :value="'Empty_Scene'+(parseInt(lastScene.key.replace(/[^0-9]/g, ''))+index+customId)" >
                    New empty Scene {{ parseInt(lastScene.key.replace(/[^0-9]/g, ''))+index+customId  }}
                  </option>
                  <option  v-for="item in scenes" :value="item.key">
                    Existing  {{ item.key.replace(/([a-z])(\d)/gi, '$1 $2') }}
                  </option>
                </select>
            </div>
 </template>
            <template v-if="(logicitem.logicNode.condition_type == 'probability' && logicitem.logicNode.no_of_scenes > 0 )">
              <label>Path</label>
              <div class="mb-2" v-for="index in parseInt(logicitem.logicNode.no_of_scenes)">
                <select class="custom-select"   v-model="logicitem.logicNode.no_of_scenes_path[index]">
                    <option :value="'Duplicated_Scene'+(parseInt(lastScene.key.replace(/[^0-9]/g, ''))+index)" >
                    New duplicated Scene {{ parseInt(lastScene.key.replace(/[^0-9]/g, ''))+index }}
                  </option>
                  <option :value="'Empty_Scene'+(parseInt(lastScene.key.replace(/[^0-9]/g, ''))+index)" >
                    New empty Scene {{ parseInt(lastScene.key.replace(/[^0-9]/g, ''))+index }}
                  </option>
                  <option  v-for="item in scenes" :value="item.key">
                    Existing  {{ item.key.replace(/([a-z])(\d)/gi, '$1 $2') }} 
                  </option>
                </select>
              </div>
      </template>
      
      <template v-if="(logicitem.logicNode.condition_type == 'stt' && logicitem.logicNode.no_of_conditions > 0 )">
              <label>Path</label>
              <div class="mb-2" v-for="index in parseInt(logicitem.logicNode.no_of_conditions)">
                <select class="custom-select"   v-model="logicitem.logicNode.no_of_scenes_path[index]">
                    <option :value="'Duplicated_Scene'+(parseInt(lastScene.key.replace(/[^0-9]/g, ''))+index)" >
                    New duplicated Scene {{ parseInt(lastScene.key.replace(/[^0-9]/g, "")) +index }}
                  </option>
                  <option :value="'Empty_Scene'+(parseInt(lastScene.key.replace(/[^0-9]/g, ''))+index)" >
                    New empty Scene {{ parseInt(lastScene.key.replace(/[^0-9]/g, "")) +index }}
                  </option>
                  <option  v-for="item in scenes" :value="item.key">
                    Existing  {{ item.key.replace(/([a-z])(\d)/gi, '$1 $2') }} 
                  </option>
                </select>
              </div>
      </template>
      
          </div>
        </div>
      </div>
    </div>
    <div v-if="logic_fields.length" class="row form-group mt-4">
      <div class="col-12 text-center">
        <button class="btn btn-primary" @click="check('done')">Save</button>
        <button class="btn btn-secondary" @click="check()">Apply</button>
      </div>
    </div>
 

   <template v-if="showModal">
      <div
        id="orphanNode"
        ref="modal"
        class="modal"
        tabindex="-1"
        role="dialog"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
           <div class="modal-header">
              <h4 class="black_font">Orphan node</h4>
              <button type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
             >
                &times;
              </button>
            </div>
               <div class="modal-body text-center">
                 <div v-for="(orphanNodeName, orphanindex) in this.orphanNodeNames">
              <h5 class="black_font">The <span class="sceneColor">{{orphanNodeName}}</span> is an orphan node now, do you want  </h5>
            <div class="row row_inModal" >
            <div class="col-md-6">
              <p class="black_font">Delete it </p>
              <button class="btn btn-danger" @click="deleteOrphanNode(orphanNodeName)"><i class="fa fa-trash"></i></button>
            </div>
            <div class="col-md-6 ">
              <p class="black_font">Link it to :</p>
              <select class="custom-select inModal" v-model="linkToNode[orphanindex]" @change="linkOrphanNode(orphanNodeName,linkToNode[orphanindex])">
                  <option  v-for="item in availableScenes" :value="item.key">
                   {{ item.key.replace(/([a-z])(\d)/gi, '$1 $2') }}
                  </option>
              </select>
            </div>
            </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </template>


 
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { uuid } from "vue-uuid";
import { db } from "../../../firebaseDB";
import Swal from 'sweetalert'
import $ from "jquery";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      showModal: false,
      activeComponent: "logic",
      logic_fields: [],
      media_names: [],
      scenes: [],
      lastScene:{},
      availableScenes:[],
      linkToNode:[],
      logics: [],
      verbaloptions:[{title:'yes'},{title:'no'},{title:'true'},{title:'false'},{title:'right'},{title:'wrong'}],
      selectIndex:'',
      diagramData: "",
      options: {
        condition_type: [
          { key: "touch", value: "Touch" },
          { key: "probability", value: "Probability" },
          // {key: 'event', value: 'Event'},
         {key: 'stt', value: 'Verbal'},
          // {key: 'non-verbal', value: 'Non-Verbal'}
        ],
        logic_type: {
          verbal: [],
          "non-verbal": [],
          touch: [
            { key: "scene", value: "Scene" },
            { key: "screen", value: "Screen" },
          ],
          event: [],
          probability: [],
        },
        media_type: {
          scene: [
            { key: "3d", value: "3d" },
            { key: "media", value: "media" },
          ],
          screen: [
            { key: "image", value: "Image" },
            { key: "video", value: "Video" },
          ],
        },
        object_type: {
          "3d": [
            { key: "character", value: "Character" },
            { key: "object3d", value: "Object 3D" },
          ],
          media: [
            { key: "image", value: "Image" },
            { key: "video", value: "Video" },
          ],
        },
        interaction_type: {
          image: [
            { key: "swipe", value: "swipe" },
            { key: "tap", value: "tap" },
          ],
          video: [
            { key: "pause", value: "pause" },
            { key: "play", value: "play" },
          ],
          object3d: [
            { key: "swipe", value: "swipe" },
            { key: "tap", value: "tap" },
          ],
          character: [
            { key: "swipe", value: "swipe" },
            { key: "tap", value: "tap" },
          ],
        },
        decision_type: {
          swipe: ["up", "right", "down", "left"],
          tap: ["tap", "double tap", "triple tap", "hold"],
        },

        path: "",
        no_of_scenes_path: [],
      },
      errors: [],
      selectAll: false,
      isSelected: false,
      currentIndex: 0,
      selectedLogic: "",
      customId:1,
      orphanNodeNames :[],
      story :null,
      updatedStory:{}
    };
  },
  created() {},
  mounted() {
 db.ref(`stories/` + localStorage.getItem("storyId") )
  .once('value')
  .then((snapshot) => {
  this.story = snapshot.val()
    this.selectedLogic = JSON.parse(localStorage.getItem("selectedLogic"));
    this.diagramData = this.story.diagram;
    this.scenes = this.diagramData.nodeDataArray.filter((node) => node.category === "Scene")
    this.lastScene = this.scenes[this.scenes.length-1]
    let storyData = this.story;
  if (storyData.json && storyData.json.mainStory && storyData.json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name).length > 0) {
      storyData = storyData.json.mainStory.nodes;
      var _this = this;
      storyData.forEach(function (column1, index1) {
        if (column1.name == _this.selectedLogic.name) {
          if (column1.nodeType == "LogicNode") {
            let verbalCondition = [];
            let no_of_scenes_path = [];
            let percentage = [];
            column1.conditions.forEach(function (column, index2) {
              let storyData = _this.story;
              if (column.conditionType == "Touch") {
                let logic_type,object_type,media_type,interaction_type,decision = [],nextScene,media_name;
                if (column.touch.touchType == "3D") {
                  logic_type = "scene";
                  media_type = "3d";
                  let nodeDataArray = (storyData && storyData.diagram? storyData.diagram.nodeDataArray || []: []).filter((n) => n.key !== "Start");
                  let selectedNodePosition = nodeDataArray.findIndex((n) => n.key == _this.selectedLogic.key);
                  let previousNodePositionKey = _this.diagramData.linkDataArray.filter((node) =>node.to === nodeDataArray[selectedNodePosition].key )[0].from;
                  let previousNodePositionElements =storyData.json.mainStory.nodes.filter((node) => node.name === previousNodePositionKey)[0].nodeElements;
                 if(previousNodePositionElements){
                  previousNodePositionElements.forEach((value, index) => {
                    if (value.elementType == "Character") {
                      if (value.character.objectId ==column.touch.objectId) {
                        object_type = value.elementType.toLowerCase();
                        media_name = value.character.name;
                      }
                    } else {
                      if (value.object3D.objectId == column.touch.objectId) {
                        object_type = value.elementType.toLowerCase();
                        media_name = value.object3D.name;
                      }
                    }
                  });
                  }
                } else if (column.touch.touchType == "2D"){
                  logic_type = "scene";
                  media_type = "media";
                  if (column.touch.objectID && column.touch.objectID.split(" ")[0].toLowerCase() =="image") {
                    object_type = "image";
                  } else {
                    object_type = "video";
                  }
                }
                _this.getMedia(object_type, index2);
                if (column.touch.interactionType.substring(0, 5) =="swipe") {
                  interaction_type = "swipe";
                  let decisionList =column.touch.interactionType.split("/");
                  if (decisionList.includes("swipeUp")) {
                    decision.push("up");
                  }
                  if (decisionList.includes("swipeRight")) {
                    decision.push("right");
                  }
                  if (decisionList.includes("swipeDown")) {
                    decision.push("down");
                  }
                  if (decisionList.includes("swipeLeft")) {
                    decision.push("left");
                  }
                } else {
                  interaction_type = "tap";
                  let decisionList =
                    column.touch.interactionType.split("/");
                  if (decisionList.includes("tap")) {
                    decision.push("tap");
                  }
                  if (decisionList.includes("doubleTap")) {
                    decision.push("double tap");
                  }
                  if (decisionList.includes("tripleTap")) {
                    decision.push("triple tap");
                  }
                  if (decisionList.includes("hold")) {
                    decision.push("hold");
                  }
                }
                if (column.touch.nextNodeID == 0) {
                  nextScene = "";
                } else {
                  nextScene =storyData.json.mainStory.nodes.find(function (node, i) {
                      if (i === column.touch.nextNodeID) {
                        return true;
                      }
                    }).name
                }
                _this.logic_fields.push({
                  elementType: "LogicNode",
                  id: uuid.v1(),
                  index: index2,
                  logicNode: {
                    condition_type: column.conditionType.toLowerCase(),
                    logic_type: logic_type,
                    object_type: object_type,
                    media_type: media_type,
                    media_name: media_name,
                    interaction_type: interaction_type,
                    no_of_scenes: parseInt(_this.lastScene.key.replace(/[^0-9]/g, '')) + index2,
                    percentage: [],
                    decision: decision,
                    path: nextScene,
                    no_of_scenes_path: [],
                    isCopied: false,
                    selectSingle: false,
                    isReadOnly:true
                  },
                });
              } else if (column.conditionType == "Probability" ) {
                if(_this.logic_fields.length==0){
                no_of_scenes_path.push('');
                  percentage.push(column.probability.chance*100);
                  no_of_scenes_path.push(
                    storyData.json.mainStory.nodes.find(function (node, i) {
                      if (i === column.probability.nextNodeID) {
                        return true;
                      }
                    }).name
                  );
                _this.logic_fields.push({
                  elementType: "LogicNode",
                  id: uuid.v1(),
                  index: index2,
                  logicNode: {
                    condition_type: column.conditionType.toLowerCase(),
                    logic_type: "",
                    object_type: "",
                    media_type: "",
                    media_name: "",
                    interaction_type: "",
                    no_of_scenes: column1.conditions.length,
                    no_of_conditions:'',
                    percentage: percentage,
                    verbalCondition:'',
                    decision: [],
                    path: "",
                    no_of_scenes_path: no_of_scenes_path,
                    isCopied: false,
                    selectSingle: false,
                    isReadOnly:true,
                  },
                });
                }else{
                  percentage.push( column.probability.chance*100);
                  no_of_scenes_path.push(
                    storyData.json.mainStory.nodes.find(function (node, i) {
                      if (i ===  column.probability.nextNodeID) {
                        return true;
                      }
                    }).name
                  );
          _this.logic_fields[0].logicNode.no_of_scenes_path=no_of_scenes_path
            _this.logic_fields[0].logicNode.percentage=percentage
                }
              }else if (column.conditionType == "STT") {
          if(_this.logic_fields.length==0){
            no_of_scenes_path.push('');
                verbalCondition.push('');
                let array = []
                column.stt.speechPhrase.forEach(function (item, i) {
                  array.push({title:item});
                  _this.verbaloptions.push({title:item}) 
                })
                verbalCondition.push(array);
                  no_of_scenes_path.push(
                    storyData.json.mainStory.nodes.find(function (node, i) {
                      if (i ===  column.stt.nextNodeID) {
                        return true;
                      }
                    }).name
                  );
                _this.logic_fields.push({
                  elementType: "LogicNode",
                  id: uuid.v1(),
                  index: index2,
                  logicNode: {
                    condition_type: column.conditionType.toLowerCase(),
                    logic_type: "",
                    object_type: "",
                    media_type: "",
                    media_name: "",
                    interaction_type: "",
                    no_of_scenes: column1.conditions.length,
                    no_of_conditions:column1.conditions.length,
                    percentage: [],
                    verbalCondition:verbalCondition,
                    decision: [],
                    path: "",
                    no_of_scenes_path: no_of_scenes_path,
                    isCopied: false,
                    selectSingle: false,
                    isReadOnly:true,
                  },
                });
          }else{
                 let array = []
                column.stt.speechPhrase.forEach(function (item, i) {
                  array.push({title:item});
                  _this.verbaloptions.push({title:item}) 
                })
                verbalCondition.push(array);
                  no_of_scenes_path.push(
                    storyData.json.mainStory.nodes.find(function (node, i) {
                      if (i ===  column.stt.nextNodeID) {
                        return true;
                      }
                    }).name
                  );
          _this.logic_fields[0].logicNode.no_of_scenes_path=no_of_scenes_path
            _this.logic_fields[0].logicNode.verbalCondition=verbalCondition
          }
          
              }
            });
          }
        }
      });
    } else {
      this.addNewLogic();
    }
     });
  },
  methods: {
    showSuccessToast(text) {
      this.$toast(text, {
        timeout: 3000,
        type: "success",
        showCloseButtonOnHover: true,
      });
    },
    showErrorToast(text) {
      this.$toast(text, {
        timeout: 3000,
        type: "error",
        showCloseButtonOnHover: true,
      });
    },
    check(status) {
     let _this=this
      _this.errors = [];
       let existedSubNode =0;
         let storyData 
      this.logic_fields.forEach(function (logic_fields, logic_index) {
        db.ref("stories").child("/" + localStorage.getItem("storyId"))
            .on('value', (snapshot) => {
             storyData = snapshot.val();
               })
        let logic = storyData.json.mainStory.nodes.filter((node) => node.name == _this.selectedLogic.key)
        if (logic[0] && logic[0].conditions[0].conditionType=='Touch' ) {
        let existedSubnodes =logic[0].conditions
        let objectID;
            _this.media_names[logic_index].forEach((value, index) => {
              if (value.name == logic_fields.logicNode.media_name) {
                objectID = value.objectId;
              }
            });
      if(_this.containsObject(logic_fields,existedSubnodes,objectID,logic_index)){
        existedSubNode=existedSubNode+1
          }
        }
        if (!logic_fields.logicNode.condition_type) {
          _this.errors.push(1);
          _this.showErrorToast("Please enter the logic type");
        } else if (
          logic_fields.logicNode.condition_type == "touch" &&
          !logic_fields.logicNode.logic_type
        ) {
          _this.errors.push(1);
          _this.showErrorToast("Please enter the logic type");
        }else if(existedSubNode != 0){
           _this.errors.push(1);
            _this.showErrorToast("this subnode already exists");
        }
      });
      if (!this.errors.length) {
        if(status=='done'){
        this.saveToDB();
         this.$router.push({ name: "mainStoryView" });
        }else{
        this.saveToDB();
        }
      }
    },

    addNewLogic() {
      const index = this.logic_fields.length;
      if (index > 0) {
        this.options.condition_type = [{ key: "touch", value: "Touch" }];
      }
        let storyData = this.story;
      if(storyData.json && storyData.json.mainStory && storyData.json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0]){
        this.customId=-storyData.json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions.length+1
      }
       while(this.scenes.filter((node) => node.key === 'Scene'+parseInt(this.lastScene.key.replace(/[^0-9]/g, '') + this.logic_fields.length + this.customId )).length>0) {
         this.customId =this.customId+1
        }
      this.logic_fields.push({
        elementType: "LogicNode",
        id: uuid.v1(),
        index: index,
        logicNode: {
          condition_type: "",
          logic_type: "",
          object_type: "",
          media_type: "",
          media_name: "",
          interaction_type: "",
          no_of_scenes: "",
          no_of_conditions:"",
          verbalCondition:[],
          percentage: [],
          decision: [],
          path: "Duplicated_Scene" + (parseInt(this.lastScene.key.replace(/[^0-9]/g, ''))+ index + this.customId),
          no_of_scenes_path: this.options.no_of_scenes_path,
          isCopied: false,
          selectSingle: false,
          isReadOnly:false
        },
      });
    },
    noElements(){
      let storyData = this.story;
      let nodeDataArray = (storyData && storyData.diagram ? storyData.diagram.nodeDataArray || []: []).filter((n) => n.key !== "Start");
      let selectedNodePosition = nodeDataArray.findIndex((n) => n.key == this.selectedLogic.key);
      let previousNodePositionKey = this.diagramData.linkDataArray.filter((node) => node.to === nodeDataArray[selectedNodePosition].key)[0].from;
      if(!storyData.json || !storyData.json.mainStory || !storyData.json.mainStory.nodes.filter((node) => node.name === previousNodePositionKey)){
          this.showErrorToast('The previous node is not saved correctly')
      }
      else if(!storyData.json.mainStory.nodes.filter((node) => node.name === previousNodePositionKey)[0].nodeElements ){
            this.showErrorToast('The previous scene has no elements')          
      }
    },
    addTag(newTag) {
      const tag = {
        title: newTag,
      };
      this.verbaloptions.push(tag);
       this.logic_fields[0].logicNode.verbalCondition[this.selectIndex].push(tag)
    },
    tagToSelect(index){
      this.selectIndex=index
    },
    probabilityPaths(scenes) {
      let s = parseInt(scenes)+1;
      for (let i = 0; i < s; i++) {
        this.options.no_of_scenes_path.push(
          "Duplicated_Scene" + (parseInt(this.lastScene.key.replace(/[^0-9]/g, '')) + i)
        );
      }
    },

    saveToDB() {
      var _this = this;
      let updates = {};
      let conditions = [];
      let json,uDiagram,key;
    // add go.js nodes
        let existedNode = 0;
         let storyData 
         _this.logic_fields.forEach(function (logic_fields, logic_index) {
           db.ref("stories").child("/" + localStorage.getItem("storyId"))
            .on('value', (snapshot) => {
             storyData = snapshot.val();
               })
        if (storyData.diagram.nodeDataArray.filter((node) => node.key === 'Scene'+logic_fields.logicNode.path.split("Scene")).length>0) {
          existedNode = existedNode+1;
        }     
         })
        if ( existedNode == 0) {
       _this.addNodes();
        }
      _this.logic_fields.forEach(function (logic_fields, logic_index) {
        db.ref("stories").child("/" + localStorage.getItem("storyId"))
        .on('value', (snapshot) => {
          storyData =snapshot.val();
        })
        var interactionType = "";
        var selectedConditionType = "";
        let nodeDataArray = (storyData && storyData.diagram ? storyData.diagram.nodeDataArray || []: []).filter((n) => n.key !== "Start");
        let selectedNodePosition = nodeDataArray.findIndex((n) => n.key == _this.selectedLogic.key);
        let previousNodePositionKey = _this.diagramData.linkDataArray.filter((node) => node.to === nodeDataArray[selectedNodePosition].key)[0].from;
        let previousNodePositionElements = storyData.json.mainStory.nodes.filter( (node) => node.name === previousNodePositionKey )[0].nodeElements;
        let previousEndTime = storyData.json.mainStory.nodes.filter( (node) => node.name === previousNodePositionKey )[0].endTime;

      json = storyData.json;
       uDiagram=storyData.diagram;
        let node = nodeDataArray[selectedNodePosition];
        if ( _this.selectedLogic.key && node && json && json.mainStory && json.mainStory.nodes) {
            switch (logic_fields.logicNode.condition_type) {
          case "touch":
            selectedConditionType = "Touch";
             logic_fields.logicNode.decision.forEach(function (column, i) {
              switch (column) {
                case "tap":
                  var selectedDecision = "tap";
                  break;
                case "double tap":
                  var selectedDecision = "doubleTap";
                  break;
                case "triple tap":
                  var selectedDecision = "tripleTap";
                  break;
                case "hold":
                  var selectedDecision = "hold";
                  break;
                case "up":
                  var selectedDecision = "swipeUp";
                  break;
                case "right":
                  var selectedDecision = "swipeRight";
                  break;
                case "left":
                  var selectedDecision = "swipeLeft";
                  break;
                case "down":
                  var selectedDecision = "swipeDown";
                  break;
                default:
                  var selectedDecision = "";
              }
              if (interactionType != "") {
                interactionType = interactionType + "/" + selectedDecision;
              } else {
                interactionType = selectedDecision;
              }
            });
            let objectID;
            _this.media_names[logic_index].forEach((value, index) => {
              if (value.name == logic_fields.logicNode.media_name) {
                objectID = value.objectId;
              }
            });
            let nextNodeId = nodeDataArray.findIndex(
              (n) =>
                n.key ==
                "Scene" + logic_fields.logicNode.path.replace(/[^0-9]/g, "")
            );
            
            if(nextNodeId!== -1 && typeof json.mainStory.nodes[selectedNodePosition] !== "undefined"
            && typeof json.mainStory.nodes[selectedNodePosition].conditions[logic_index]!== "undefined"
            && typeof json.mainStory.nodes[selectedNodePosition].conditions[logic_index].touch!== "undefined"
            && json.mainStory.nodes[selectedNodePosition].conditions[logic_index].touch.nextNodeID !== nextNodeId
            && nextNodeId!== -1
            ){
            
           //   if change path add new empty condition
           conditions.push({
              conditionType: selectedConditionType,
              "touch": {
                "touchType": '',
                "objectId": '',
                "priority": 1,
                "interactionType": '',
                "nextNodeID": json.mainStory.nodes[selectedNodePosition].conditions[logic_index].touch.nextNodeID
              }
            }); 
            }
            conditions.push({
              conditionType: selectedConditionType,
              "touch": {
                "touchType": logic_fields.logicNode.media_type.toUpperCase(),
                "objectId": objectID,
                "priority": 1,
                "interactionType": interactionType,
                "nextNodeID": nextNodeId
              }
            });     
            
            json.mainStory.nodes[selectedNodePosition] = {
              name: node.key,
              nextNodeID: parseInt(selectedNodePosition) + 1,
              conditions: conditions,
              nodeId: selectedNodePosition,
              nodeType: "LogicNode",
            };
            
             _this.logic_fields.forEach(function (logic_field, logic_index) {
              nextNodeId = nodeDataArray.findIndex((n) =>n.key =="Scene" + logic_field.logicNode.path.replace(/[^0-9]/g, ""));
              let scenenode = nodeDataArray[nextNodeId]; 
            if (logic_field.logicNode.path.includes("Empty") || !previousNodePositionElements) {
              json.mainStory.nodes[nextNodeId] = {
                name: scenenode.key,
                nodeId: nextNodeId,
                nodeType: "SceneNode",
                nextNodeID: -1,
                startTime: 0,
                endTime: 20,
              };
            } else if (logic_field.logicNode.path.includes("Duplicated") && previousNodePositionElements) {
              json.mainStory.nodes[nextNodeId] = {
                name: scenenode.key,
                nodeId: nextNodeId,
                nodeType: "SceneNode",
                nextNodeID: -1,
                startTime: 0,
                endTime: previousEndTime,
                nodeElements: previousNodePositionElements,
              };
            }
             })
            break;
          case "probability":
            selectedConditionType = "Probability";
             logic_fields.logicNode.percentage.forEach((value, Index) => {
              let nextNodeId = nodeDataArray.findIndex(
                (n) =>
                  n.key ==
                  "Scene" +
                    logic_fields.logicNode.no_of_scenes_path[Index].replace(
                      /[^0-9]/g,
                      ""
                    )
              );
             if(nextNodeId!== -1 && typeof json.mainStory.nodes[selectedNodePosition] !== "undefined"
            && typeof json.mainStory.nodes[selectedNodePosition].conditions[Index-1]!== "undefined"
            && typeof json.mainStory.nodes[selectedNodePosition].conditions[Index-1].probability !== "undefined"
            && json.mainStory.nodes[selectedNodePosition].conditions[Index-1].probability.nextNodeID !== nextNodeId
            ){
           //   if change path change scenenode name
           nextNodeId = json.mainStory.nodes[selectedNodePosition].conditions[Index-1].probability.nextNodeID
           let linkToDelete =uDiagram.linkDataArray.findIndex((n) => n.to == "Scene" +logic_fields.logicNode.no_of_scenes_path[Index].replace( /[^0-9]/g,""));
           let nodeToDelete =uDiagram.nodeDataArray.findIndex((n) => n.key == "Scene" +logic_fields.logicNode.no_of_scenes_path[Index].replace( /[^0-9]/g,""));
            uDiagram.linkDataArray.splice(linkToDelete, 1)
            uDiagram.nodeDataArray.splice(nodeToDelete, 1)
            let oldNodeId = uDiagram.nodeDataArray.findIndex((node) => node.key ==json.mainStory.nodes[nextNodeId].name);
            let oldLinkId = uDiagram.linkDataArray.findIndex((node) => node.to ==json.mainStory.nodes[nextNodeId].name);
            uDiagram.nodeDataArray[oldNodeId].key = "Scene" +logic_fields.logicNode.no_of_scenes_path[Index].replace( /[^0-9]/g,"")
            uDiagram.linkDataArray[oldLinkId].to = "Scene" +logic_fields.logicNode.no_of_scenes_path[Index].replace( /[^0-9]/g,"")
          json.mainStory.nodes[nextNodeId] = {
                  name: "Scene" +logic_fields.logicNode.no_of_scenes_path[Index].replace( /[^0-9]/g,""),
                  nodeId: nextNodeId,
                  nodeType: "SceneNode",
                  nextNodeID: -1,
                  startTime: 0,
                  endTime: 20,
                };
              }
              if(nextNodeId!==-1){
              conditions.push({
                conditionType: "Probability",
                probability: {
                  nextNodeID: nextNodeId,
                  chance: parseFloat(value / 100)
                           }
              });
              }
            });
             logic_fields.logicNode.percentage.forEach((value, Index) => {
            json.mainStory.nodes[selectedNodePosition] = {
              name: node.key,
              nodeId: selectedNodePosition,
              conditions:conditions,
              nodeType: "LogicNode",
              nextNodeID: parseInt(selectedNodePosition) + 1,
            };
              let scenenode = nodeDataArray[selectedNodePosition + Index];
              if (logic_fields.logicNode.no_of_scenes_path[Index].includes("Empty") || !previousNodePositionElements) {
                json.mainStory.nodes[selectedNodePosition + Index] = {
                  name: scenenode.key,
                  nodeId: selectedNodePosition + Index,
                  nodeType: "SceneNode",
                  nextNodeID: -1,
                  startTime: 0,
                  endTime: 20,
                };
              } else if (logic_fields.logicNode.no_of_scenes_path[Index].includes( "Duplicated") && previousNodePositionElements) {
                json.mainStory.nodes[selectedNodePosition + Index] = {
                  name: scenenode.key,
                  nodeId: selectedNodePosition + Index,
                  nodeType: "SceneNode",
                  nextNodeID: -1,
                  startTime: 0,
                  endTime: previousEndTime,
                  nodeElements: previousNodePositionElements,
                };
              }
            });
            break;
          case "stt":
            selectedConditionType = "STT";
              logic_fields.logicNode.verbalCondition.forEach((value, Index) => {
                let listWords =[]
              let nextNodeId = nodeDataArray.findIndex((n) => n.key =="Scene" +logic_fields.logicNode.no_of_scenes_path[Index].replace( /[^0-9]/g,""));
             if(Index>0){
               value.forEach((item, i) => {
                    listWords.push(item.title)
               })
            if(nextNodeId!== -1 && typeof json.mainStory.nodes[selectedNodePosition] !== "undefined"
            && typeof json.mainStory.nodes[selectedNodePosition].conditions[Index-1]!== "undefined"
            && typeof json.mainStory.nodes[selectedNodePosition].conditions[Index-1].stt !== "undefined"
            && json.mainStory.nodes[selectedNodePosition].conditions[Index-1].stt.nextNodeID !== nextNodeId
            ){
           //   if change path change scenenode name
           nextNodeId = json.mainStory.nodes[selectedNodePosition].conditions[Index-1].stt.nextNodeID
           let linkToDelete =uDiagram.linkDataArray.findIndex((n) => n.to == "Scene" +logic_fields.logicNode.no_of_scenes_path[Index].replace( /[^0-9]/g,""));
           let nodeToDelete =uDiagram.nodeDataArray.findIndex((n) => n.key == "Scene" +logic_fields.logicNode.no_of_scenes_path[Index].replace( /[^0-9]/g,""));
            uDiagram.linkDataArray.splice(linkToDelete, 1)
            uDiagram.nodeDataArray.splice(nodeToDelete, 1)
            let oldNodeId = uDiagram.nodeDataArray.findIndex((node) => node.key ==json.mainStory.nodes[nextNodeId].name);
            let oldLinkId = uDiagram.linkDataArray.findIndex((node) => node.to ==json.mainStory.nodes[nextNodeId].name);
            uDiagram.nodeDataArray[oldNodeId].key = "Scene" +logic_fields.logicNode.no_of_scenes_path[Index].replace( /[^0-9]/g,"")
            uDiagram.linkDataArray[oldLinkId].to = "Scene" +logic_fields.logicNode.no_of_scenes_path[Index].replace( /[^0-9]/g,"")
           json.mainStory.nodes[nextNodeId] = {
                  name: "Scene" +logic_fields.logicNode.no_of_scenes_path[Index].replace( /[^0-9]/g,""),
                  nodeId: nextNodeId,
                  nodeType: "SceneNode",
                  nextNodeID: -1,
                  startTime: 0,
                  endTime: 20,
                };
              }
             conditions.push({
                "conditionType": "STT",
                "stt": {
                "speechPhrase": listWords,
                "nextNodeID": nextNodeId
                    }
                            })
             }
              })
            
     
          if(!json.mainStory.nodes[selectedNodePosition]){
            json.mainStory.nodes[selectedNodePosition] = {
              name: node.key,
              nodeId: selectedNodePosition,
              nodeType: "LogicNode",
              nextNodeID: parseInt(selectedNodePosition) + 1,
              conditions: conditions,
            };
            logic_fields.logicNode.verbalCondition.forEach((value, Index) => {
              let scenenode = nodeDataArray[selectedNodePosition + Index];
              if (logic_fields.logicNode.no_of_scenes_path[Index].includes("Empty") || !previousNodePositionElements) {
                json.mainStory.nodes[selectedNodePosition + Index] = {
                  name: scenenode.key,
                  nodeId: selectedNodePosition + Index,
                  nodeType: "SceneNode",
                  nextNodeID: -1,
                  startTime: 0,
                  endTime: 20,
                };
              } else if ( logic_fields.logicNode.no_of_scenes_path[Index].includes("Duplicated") && previousNodePositionElements) {
                json.mainStory.nodes[selectedNodePosition + Index] = {
                  name: scenenode.key,
                  nodeId: selectedNodePosition + Index,
                  nodeType: "SceneNode",
                  nextNodeID: -1,
                  startTime: 0,
                  endTime: previousEndTime,
                  nodeElements: previousNodePositionElements,
                };
              }
            });
            }else{
              json.mainStory.nodes[selectedNodePosition] = {
              name: node.key,
              nodeId: selectedNodePosition,
              nodeType: "LogicNode",
              nextNodeID: parseInt(selectedNodePosition) + 1,
              conditions: conditions,
            };
            }
            break;
          default:
            selectedConditionType = selectedConditionType;
        }
// change previous node nextNodeID 
          let previousNodePositionKey = _this.diagramData.linkDataArray.filter((node) => node.to === nodeDataArray[selectedNodePosition].key)[0].from;
          if ( json.mainStory.nodes.filter((node) => node.name === previousNodePositionKey ).length > 0) {
            let previousNodePosition = json.mainStory.nodes.filter((node) => node.name === previousNodePositionKey )[0].nodeId;
            json.mainStory.nodes[parseInt(previousNodePosition)].nextNodeID =selectedNodePosition;
          }
        }
          updates[localStorage.getItem("storyId") + `/json`] = json;
          updates[localStorage.getItem("storyId") + `/diagram`] = uDiagram;
         db.ref("stories").update(updates).then((snapshot) => {});
        
         
      });
        
    },
 containsObject(obj, list,objectID,logicIndex) {
    var interactionType = "";
    let incr =0
      obj.logicNode.decision.forEach(function (column, i) {
   switch (column) {
                case "tap":
                  var selectedDecision = "tap";
                  break;
                case "double tap":
                  var selectedDecision = "doubleTap";
                  break;
                case "triple tap":
                  var selectedDecision = "tripleTap";
                  break;
                case "hold":
                  var selectedDecision = "hold";
                  break;
                case "up":
                  var selectedDecision = "swipeUp";
                  break;
                case "right":
                  var selectedDecision = "swipeRight";
                  break;
                case "left":
                  var selectedDecision = "swipeLeft";
                  break;
                case "down":
                  var selectedDecision = "swipeDown";
                  break;
                default:
                  var selectedDecision = "";
              }
              if (interactionType != "") {
                interactionType = interactionType + "/" + selectedDecision;
              } else {
                interactionType = selectedDecision;
              }
               })
         let obj2={
            "conditionType": 'Touch',
              "touch": {
                "touchType": obj.logicNode.media_type.toUpperCase(),
                "objectId": objectID,
                "priority": 1,
                "interactionType": interactionType,
                      }
              }
              var i;
            for (i = 0; i < list.length; i++) {
              if(logicIndex!=i){
            list[i]={
              "conditionType": list[i].conditionType,
              "touch": {
                "touchType":list[i].touch.touchType,
                "objectId": list[i].touch.objectId,
                "priority": list[i].touch.priority,
                "interactionType": list[i].touch.interactionType,
                      }
            }
                  if(list[i].conditionType==obj2.conditionType){incr+= 1;}
                  if(list[i].touch.touchType==obj2.touch.touchType){incr+= 1;}
                  if(list[i].touch.objectId==obj2.touch.objectId){incr+= 1;}
                  if(list[i].touch.priority==obj2.touch.priority){incr+= 1;}
                  if(list[i].touch.interactionType==obj2.touch.interactionType){incr+= 1;}
                if(incr==5){return true}
              }
            }
            return false;
},
    addNodes() {
      let scenesKeyArray = [];
      let update = [];
      let storyData =[]
      this.scenes.forEach((value, index) => {scenesKeyArray.push(value.key);});
      db.ref("stories").child("/" + localStorage.getItem("storyId"))
        .on('value', (snapshot) => {
          storyData =snapshot.val();
        })
      this.logic_fields.forEach((Value, Index) => {
        if (Value.logicNode.condition_type == "touch") {
          if (scenesKeyArray.indexOf(Value.logicNode.path) !== -1) {
             // link to existing node
                if (storyData.diagram.linkDataArray.filter((node) => node.from === this.selectedLogic.key).length==0 
                && (storyData.diagram.linkDataArray.filter((node) => node.to === Value.logicNode.path).length==0)) {
              let goDiagram = new go.GraphLinksModel(
                storyData.diagram.nodeDataArray,
                storyData.diagram.linkDataArray
              );
              goDiagram.addLinkData({
                from: this.selectedLogic.key,
                to: Value.logicNode.path,
              });
              goDiagram.commitTransaction("added Link");
              update = storyData.diagram;
                }
          } else {
            // create new node and link
              if (storyData.diagram.nodeDataArray.filter((node) => node.key === Value.logicNode.path).length==0) {
              let scenesArray= storyData.diagram.nodeDataArray.filter((node) => node.category === "Scene")
              let scenesCount = parseInt(scenesArray[scenesArray.length - 1].key.replace(/[^0-9]/g,""))
              let goDiagram = new go.GraphLinksModel(
                storyData.diagram.nodeDataArray,
                storyData.diagram.linkDataArray
              );
              goDiagram.addLinkData({
                from: this.selectedLogic.key,
                to:Value.logicNode.path.split("_")[1],
              });
              goDiagram.addNodeData({
                key: Value.logicNode.path.split("_")[1],
                category: "Scene",
                isGroup: false,
                ungroupable: true,
                fig: "Square",
                color: "#f634a5",
                width: 60,
                height: 60,
                margin: 4,
              });
              goDiagram.commitTransaction("added Node and Link");
              update = storyData.diagram;
                }

          }
          
        } else if ( Value.logicNode.condition_type == "stt") {
            Value.logicNode.verbalCondition.forEach((value, Index) => {
              let goDiagram = new go.GraphLinksModel(
                storyData.diagram.nodeDataArray,
                storyData.diagram.linkDataArray
              );
              if(scenesKeyArray.indexOf(Value.logicNode.no_of_scenes_path[Index]) === -1){
              if (!Value.logicNode.no_of_scenes_path[Index].includes( "Empty" ) && !Value.logicNode.no_of_scenes_path[Index].includes("Duplicated")) {
                // link to existing node
                goDiagram.addLinkData({
                  from: this.selectedLogic.key,
                  to: Value.logicNode.no_of_scenes_path[Index],
                });
                goDiagram.commitTransaction("added Link");
              } else {
                // create new node and link
                goDiagram.addLinkData({
                  from: this.selectedLogic.key,
                  to: Value.logicNode.no_of_scenes_path[Index].split(
                    "_"
                  )[1],
                });
                goDiagram.addNodeData({
                  key: Value.logicNode.no_of_scenes_path[Index].split(
                    "_"
                  )[1],
                  category: "Scene",
                  isGroup: false,
                  ungroupable: true,
                  fig: "Square",
                  color: "#f634a5",
                  width: 60,
                  height: 60,
                  margin: 4,
                });
                goDiagram.commitTransaction("added Node and Link");
              }
              }
  
          update = storyData.diagram;
          });
        }else if (Value.logicNode.condition_type == "probability") {
            Value.logicNode.percentage.forEach((value, Index) => {
              let goDiagram = new go.GraphLinksModel(
                storyData.diagram.nodeDataArray,
                storyData.diagram.linkDataArray
              );
              if (
                !Value.logicNode.no_of_scenes_path[Index].includes(
                  "Empty"
                ) &&
                !Value.logicNode.no_of_scenes_path[Index].includes(
                  "Duplicated"
                )
              ) {
                // link to existing node
                goDiagram.addLinkData({
                  from: this.selectedLogic.key,
                  to: Value.logicNode.no_of_scenes_path[Index],
                });
                goDiagram.commitTransaction("added Link");
              } else {
                // create new node and link
                goDiagram.addLinkData({
                  from: this.selectedLogic.key,
                  to: Value.logicNode.no_of_scenes_path[Index].split(
                    "_"
                  )[1],
                });
                goDiagram.addNodeData({
                  key: Value.logicNode.no_of_scenes_path[Index].split(
                    "_"
                  )[1],
                  category: "Scene",
                  isGroup: false,
                  ungroupable: true,
                  fig: "Square",
                  color: "#f634a5",
                  width: 60,
                  height: 60,
                  margin: 4,
                });
                goDiagram.commitTransaction("added Node and Link");
              }
            });
          update = storyData.diagram;
      

        }
     
      });
     db.ref(`stories/` + localStorage.getItem("storyId") + `/diagram`).update(update)
    },
    deleteLogic(items) {
      if(!items.length){
      let item = items
       Swal({
        title: `Are you sure you want to delete this subnode ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        focusConfirm: false,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!'
      }).then((result) => {
       if (result) {
       let storyData = this.story;
       let nodes = storyData.json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)
      let StoryID =localStorage.getItem("storyId") 
      if(nodes[0] && nodes[0].conditions.length>1){
        var idx =   this.logic_fields.indexOf(item);
        let nextNodeName = storyData.json.mainStory.nodes.filter((node) => node.nodeId === nodes[0].conditions[idx].touch.nextNodeID)[0].name
        let linkDataNodeID =storyData.diagram.linkDataArray.findIndex((n) => n.to == nextNodeName);
        storyData.diagram.linkDataArray.splice(linkDataNodeID, 1)
          nodes[0].conditions.splice(idx, 1) 
           nodes[0].conditions.forEach(function (condition, index) {
             if(index>=idx){
                nodes[0].conditions[index].touch.nextNodeID = nodes[0].conditions[index].touch.nextNodeID-1
              }
          })
         db.ref(`stories/${StoryID}/`).update(storyData).then((snapshot) => {
         if (idx > -1) {
          this.logic_fields.splice(idx, 1);
          this.showModal = true;
          let scenes = storyData.diagram.nodeDataArray.filter((node) => node.category === "Scene");
           scenes.forEach(element => {
              let nextNodeId = storyData.json.mainStory.nodes.filter((node) => node.name === element.key)[0].nextNodeID
             if(nextNodeId==-1 && element.key!=nextNodeName){
             this.availableScenes.push(element)
             }
           });          
        this.$nextTick(() => {
           this.orphanNodeNames.push(nextNodeName)
            $("#orphanNode").modal("show");
          });
         
        }
      });
      }
       }
       })
   }else if(items.length>1){
     Swal({
        title: `Are you sure you want to delete these subnodes ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        focusConfirm: false,
        confirmButtonText: 'Yes, delete them !',
        cancelButtonText: 'No, cancel!'
      }).then((result) => {
      if (result) {
      let storyData = this.story;
      let nodes = storyData.json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)
      let StoryID =localStorage.getItem("storyId") 
      if(nodes[0] && nodes[0].conditions.length>1){
        let this_ =this
        let nextNodeNames =[]
        items.forEach(function (item, index) {
            index = this_.logic_fields.indexOf(item);
            nextNodeNames.push(storyData.json.mainStory.nodes.filter((node) => node.nodeId === nodes[0].conditions[index].touch.nextNodeID)[0].name)
            this_.orphanNodeNames.push(storyData.json.mainStory.nodes.filter((node) => node.nodeId === nodes[0].conditions[index].touch.nextNodeID)[0].name)
        })
        items.forEach(function (item, index1) {
           let index = this_.logic_fields.indexOf(item);
        let linkDataNodeID =storyData.diagram.linkDataArray.findIndex((n) => n.to == storyData.json.mainStory.nodes.filter((node) => node.nodeId === nodes[0].conditions[index-index1].touch.nextNodeID)[0].name);
        storyData.diagram.linkDataArray.splice(linkDataNodeID, 1)
          nodes[0].conditions.splice(index-index1, 1) 
           nodes[0].conditions.forEach(function (condition, index2) {
             if(index2>=(index-index1)){
                nodes[0].conditions[index2].touch.nextNodeID = nodes[0].conditions[index2].touch.nextNodeID-1
              }
          })
        })
      
         db.ref(`stories/${StoryID}/`).update(storyData).then((snapshot) => {
           let this_ =this
           let scenes
            items.forEach(function (item, index) {
              index = this_.logic_fields.indexOf(item);
         if (index > -1) {
          this_.showModal = true;
           scenes = storyData.diagram.nodeDataArray.filter((node) => node.category === "Scene");
        }
        });
          scenes.forEach(element => {
              let nextNodeId = storyData.json.mainStory.nodes.filter((node) => node.name === element.key)[0].nextNodeID
             if(nextNodeId==-1 && (nextNodeNames.indexOf(element.key) === -1)){
             this.availableScenes.push(element)
             }
           });
        items.forEach(function (item, index) {
          this_.logic_fields.splice(index, 1);
        })
         this.$nextTick(() => {
         $("#orphanNode").modal("show");
         });
      });
      }

       }
       })
  
   }
   },
    deleteOrphanNode(key){
      let StoryID =localStorage.getItem("storyId")
        let storyData = this.story;
          let NodeID = storyData.json.mainStory.nodes.findIndex((node) => node.name === key)
          let DataNodeID =storyData.diagram.nodeDataArray.findIndex((n) => n.key == key); 
          storyData.json.mainStory.nodes.splice(NodeID, 1) 
         storyData.json.mainStory.nodes.forEach(function (node, index) {
             if(index>=NodeID){
                storyData.json.mainStory.nodes[index].nodeId = storyData.json.mainStory.nodes[index].nodeId-1
              }
          })
          storyData.diagram.nodeDataArray.splice(DataNodeID, 1)

          db.ref(`stories/${StoryID}/`).update(storyData) 
            //$("#orphanNode").modal("hide");
    },
    
    linkOrphanNode(orphanKey,toNodeKey){
        let StoryID =localStorage.getItem("storyId")
        let storyData = this.story;
        let orphanNode =storyData.json.mainStory.nodes.filter((node) => node.name=== orphanKey )[0]
        storyData.json.mainStory.nodes.filter((node) => node.name=== toNodeKey )[0].nextNodeID = orphanNode.nodeId;
         let goDiagram = new go.GraphLinksModel(
                storyData.diagram.nodeDataArray,
                storyData.diagram.linkDataArray
              );
              goDiagram.addLinkData({
                from: toNodeKey,
                to: orphanKey,
              });
              goDiagram.commitTransaction("added Link");
       db.ref(`stories/${StoryID}/`).update(storyData) 
       //  $("#orphanNode").modal("hide");
    },
    copyLogic(index, item) {
      this.logic_fields.isCopied = ! this.logic_fields.isCopied;
      this.getMedia(item.logicNode.object_type, this.logic_fields.length);
       let storyData = this.story;
      if(storyData.json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0]){
        this.customId=-storyData.json.mainStory.nodes.filter((node) => node.name === this.selectedLogic.name)[0].conditions.length+1
      }
       while(this.scenes.filter((node) => node.key === 'Scene'+(parseInt(this.lastScene.key.replace(/[^0-9]/g, '')) + this.logic_fields.length + this.customId )).length>0) {
         this.customId =this.customId+1
        }
      this.logic_fields.push({
                  elementType: "LogicNode",
                  id: uuid.v1(),
                  index: this.logic_fields.length,
                  logicNode: {
                    condition_type:item.logicNode.condition_type,
                    logic_type: item.logicNode.logic_type,
                    object_type: item.logicNode.object_type,
                    media_type: item.logicNode.media_type,
                    media_name: item.logicNode.media_name,
                    interaction_type: item.logicNode.interaction_type,
                    decision: item.logicNode.decision,
                    path: "Duplicated_Scene" + (parseInt(this.lastScene.key.replace(/[^0-9]/g, '')) + this.logic_fields.length + this.customId ),
                    isCopied: true,
                    selectSingle: false,
                  },
      });
    },
    deleteAllLogic() {
     let logics =[]
     this.logic_fields.forEach((value) => {
        if(value.logicNode.selectSingle){
          logics.push(value)
        }
        //return !value.logicNode.selectSingle;
      });
     this.deleteLogic(logics)
    },
    checkSingleSelect() {
      this.logic_fields.forEach((value) => {
        if (value.logicNode.selectSingle) {
          this.isSelected = true;
        }
      });
    },
    getMedia(type, logic_index) {
      this.media_names[logic_index] = [];
      let storyData = this.story;
      let nodeDataArray = (
        storyData && storyData.diagram
          ? storyData.diagram.nodeDataArray || []
          : []
      ).filter((n) => n.key !== "Start");
      let selectedNodePosition = nodeDataArray.findIndex(
        (n) => n.key == this.selectedLogic.key
      );
      let previousNodePositionKey = this.diagramData.linkDataArray.filter(
        (node) => node.to === nodeDataArray[selectedNodePosition].key
      )[0].from;
      let previousNodePosition = storyData.json.mainStory.nodes.filter(
        (node) => node.name === previousNodePositionKey
      )[0].nodeElements;
      if (type == "image") {
        this.media_names[logic_index] = [
          "Image 1",
          "Image 2",
          "Image 3",
          "Image 4",
          "Image 5",
        ];
      } else if (type == "video") {
        this.media_names[logic_index] = [
          "Video 1",
          "Video 2",
          "Video 3",
          "Video 4",
          "Video 5",
        ];
      } else if (type == "character") {
        previousNodePosition.forEach((node, index) => {
          if (node.elementType == "Character") {
            this.media_names[logic_index].push({
              objectId: node.character.objectId,
              name: node.character.name,
            });
          }
        });
      } else if (type == "object3d") {
        previousNodePosition.forEach((node, index) => {
          if (node.elementType == "Object3D") {
            this.media_names[logic_index].push({
              objectId: node.object3D.objectId,
              name: node.object3D.name,
            });
          }
        });
      }
    },
  },
  watch: {
    selectAll: function (val) {
      this.isSelected = !!val;
      if (this.logic_fields) {
        this.logic_fields.forEach((value) => {
          value.logicNode.selectSingle = val;
        });
      }
    },
  },
  computed: {},
};
</script>
<style>
.logic-item-decision {
  width: -webkit-fill-available;
}
.inspector-wrap.logic-wrapper .fields-wrapper .logic-fields-wrap {
  align-items: normal;
}
.logic-item {
  width: 20%;
  margin: 0 2% 0 2%;
}
.extendable{
  width: 80%;
}
.logic-items-list {
  display: flex;
}
.black_font{
  color:black
}
.sceneColor{color:#FF99C8}
.inModal{width:auto}
.row_inModal{min-width: auto;}
body{padding-right: 0px!important;}
</style>


// WEBPACK FOOTER //
// src/components/v2/story-edit-view/logic.vue